import { Field } from 'formik'
import React from 'react'

import { Fieldset, Input, Subsection } from '@fourthwall/components'

export const CreatorDetails = () => (
  <Subsection title="Creator details">
    <Fieldset>
      <Fieldset.Row>
        <Field
          name="creatorName"
          component={Input}
          label="Creator name"
          suggestion="Supporters will see your creator name during checkout and on marketing emails."
          required
          fullWidth
        />
      </Fieldset.Row>
      <Fieldset.Row>
        <Field
          name="customerSupportEmail"
          component={Input}
          label="Customer support email address"
          suggestion="Email address where we’ll forward emails we’re unable to answer for you (e.g., a sponsorship offer or a question about a product you’re shipping)"
          required
          fullWidth
        />
      </Fieldset.Row>
    </Fieldset>
  </Subsection>
)
